import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityCashBalanceBucketDTO } from '../Type/PackEntityCashBalanceBucketDTO'

interface DataModel {
	cid?: string
}

/**
 *	根据cid查询四个余额桶余额
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.cid] 企业id
 */

export function queryBalanceBucket(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityCashBalanceBucketDTO>
export function queryBalanceBucket(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityCashBalanceBucketDTO extends { msg: unknown } ? PackEntityCashBalanceBucketDTO['msg'] : undefined>
export function queryBalanceBucket(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { cid } = data
	return net('/frontApi/cust/queryBalanceBucket', {
		method: 'post',
		params: {
			cid,
		},

		...(options || {}),
	})
}
